import { render, staticRenderFns } from "./warnInfo.vue?vue&type=template&id=4087ad22&scoped=true&"
import script from "./warnInfo.vue?vue&type=script&lang=js&"
export * from "./warnInfo.vue?vue&type=script&lang=js&"
import style0 from "./warnInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./warnInfo.vue?vue&type=style&index=1&id=4087ad22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087ad22",
  null
  
)

export default component.exports